module.exports = __webpack_public_path__ + "static/media/Lips_1.b8526271.svg";